import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { BaseParamsService } from '@app/core/base-params.service';
import { SignedInGuard } from '@app/core/guards/signed-in.guard';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionService } from '@app/core/session/session.service';

export const receiptScannerAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const signedInGuard = inject(SignedInGuard);
  const baseParamsService = inject(BaseParamsService);
  const sessionService = inject(SessionService);

  baseParamsService.parseParams(route);
  const token = baseParamsService.memberAccessToken;

  if (token) {
    return sessionService.createSessionFromMemberToken(token).pipe(
      switchMap(result => result ? of(true) : signedInGuard.canActivate(route)),
      catchError(() => signedInGuard.canActivate(route))
    );
  }
  return signedInGuard.canActivate(route);
};
